import QuotationSubmit from "app/pages/Booking/Quotation/Submit/QuotationSubmit";
import { useSelector, shallowEqual } from "react-redux";
import {
	calculateCreditBasedOnQuoteBase,
	calculatePreBookTotal,
	getSavingsData,
	getTotalExcludedTaxes,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import {
	checkIsCreditUsageIsEnabled,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = state => {
	const isCreditEnabled = checkIsCreditUsageIsEnabled(state);
	const creditsApplied = isCreditEnabled ? calculateCreditBasedOnQuoteBase(state) : 0;
	const totalExcludedTaxes = getTotalExcludedTaxes(state);
	const total = calculatePreBookTotal(state) - creditsApplied + totalExcludedTaxes;
	const passengersCount = state.booking.adults + state.booking.children;
	const pricePerPerson = passengersCount > 0 ? Math.floor(total / passengersCount) : 0;
	return {
		hasChildren: state.booking.children > 0,
		depositPercentage: getPartnerDepositPercentage(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		total: total,
		pricePerPerson: pricePerPerson,
		savingsTotalAmount: getSavingsData(state).amountSaved || 0,
		resolution: state.resolution,
	};
};

const QuotationSubmitContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <QuotationSubmit {...props} {...stateProps} />;
};

export default QuotationSubmitContainer;
